
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-approach",
      function () {
        return require("private-next-pages/our-approach/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-approach"])
      });
    }
  